<div class="floatLabel inputPrincipal" [ngClass]="{'soloLectura' : disabled, 'sinMargenControl' : !margenControl}">

  <!-- Input -->
  <input id="input{{id}}" [(colorPicker)]="valor" [(ngModel)]="valor" [ngClass]="{'is-filled': (input.value), 'inputDeshabilitado' : disabled}" #input="ngModel" #colorPickerInput
         [cpAlphaChannel]="verAlpha" [cpCancelButton]="true" [cpCancelButtonClass]= "'boton botonXS filledBlanco'" [cpOKButton]="true" [cpOKButtonClass]= "'boton botonXS filled'" [cpIgnoredElements]="[colorPickerInput, colorPickerInput]" [(cpToggle)]="colorAbierto" (focus)="colorPickerInput.blur(); colorAbierto = true" (cpToggleChange)="CambioColorAbierto($event)"
         class="form-control inputColor"  required>

  <!-- Título -->
  <label>{{titulo}}</label>

  <!-- circulo color -->
  <div class="cirucloColor" [style.background]="valor" *ngIf="valor">
  </div>

  <!-- Button limpiar --->
  <button *ngIf="(input.value || input.value === 0) && !disabled" (click)="LimpiarValor()"
          class="btnTimes" tabindex="-1">
    <span class="fa fa-times"></span>
  </button>

  <!-- Mensaje de error -->
  <span [hidden]="!verError || input.valid || (!touched && !errorActivo)"
        class="textoError" >
    {{mensajeError ? (mensajeError | translate) : ('DatoIncompeto' | translate)}}
  </span>

</div>

